export const NAVIGATION_BAR_ANCHOR_CLASS = 'navigation-bar-anchor-component';

export const ANCHOR_COMPONENT = 'NavigationBarAnchorComponent';

export const NAVIGATION_BAR_LABEL = 'Series Detail Nav Bar';
